import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

interface ColorProps {
    themeColor: string;
    themeBg: string;
}

export const PHASE_STYLES: Record<
    'product' | 'technical',
    { color: string; bg: string; label: string }
> = {
    product: {
        color: '#4dabf7',
        bg: 'rgba(77,171,247,0.12)',
        label: 'Product'
    },
    technical: {
        color: '#b197fc',
        bg: 'rgba(177,151,252,0.12)',
        label: 'Technical'
    }
};

export const BadgeContainer = styled(Box)<ColorProps>`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 12px;
    margin-bottom: 16px;
    margin-left: 8px;
    border-radius: 6px;
    background-color: ${({ themeBg }) => themeBg};
    border: 1px solid ${({ themeColor }) => themeColor}30;
`;

export const PhaseLabel = styled(Typography)<ColorProps>`
    font-size: 13px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    color: ${({ themeColor }) => themeColor};
    line-height: 1;
`;
